import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import ContactSectionNew from '../components/ContactSectionNew';
import SEOHelmet from '../components/SEOHelmet';

const Contact = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHelmet 
        title="Contact Us"
        description="Get in touch with Meta Cell Technology to learn how our photothermal biomodulation technology can transform your regenerative medicine practice. Request a demo today."
        keywords="PRP technology contact, exosome therapy inquiry, regenerative aesthetics consultation, MCT demo request, medical device inquiry"
      />
      <Navigation />
      
      <div className="pt-20">
        <ContactSectionNew />
      </div>

      <Footer />
    </div>
  );
};

export default Contact;